import axios from './http';

/**
 * cm原用户与cm福利关卡列表
 * @param {string} categoryDivideId cmlist's current tab
 */
export function getCMlist(params) {
  const { categoryDivideId } = params;
  return axios.get(`/core/cm/solution/divide/${categoryDivideId}`);
}

/**
 * 保存codemonkey的答题结果 星星数
 * @param {string} code
 * @param {number} projectId
 * @param {number} stars 获得星星数
 * @param {number} time
 */
export function saveCMStars(params) {
  return axios.post('/core/cm/solution/special', params);
}
